function applySwatchColors(){
    if (!window.swatches) return
    const swatchElements = document.querySelectorAll('.swatch-element');
    if (!swatchElements) return
    swatchElements.forEach(color => {
      const option = color.dataset.optionValue;
      if(window.swatches[option] != undefined){
        let color_image = window.swatches[option].color_image;
        let color_picker = window.swatches[option].color_picker;
        if(color_image){
          color.querySelector('.color_block').style.backgroundImage = "url('"+ color_image + "')";
        }else{
          color.querySelector('.color_block').style.backgroundColor = color_picker;
        }
      }
    });
}

var tag_variant = document.querySelector('[data-tag]').attributes[0].value;
if(!tag_variant){
  document.querySelectorAll('.swatch.variant-default').forEach(block => block.style.display = 'block')
  applySwatchColors()
}
fetch('/search?view=json&q=tag:"' + encodeURI(tag_variant) + '"', {method: "GET"}).then((response) => {
    return response.json();
  }).then((data) => {
      var current_product_id = document.querySelector('[data-product-id]').dataset.productId;
      var current_product = data.results.find(product => product.id == current_product_id);
      if(!tag_variant || !current_product){
        document.querySelectorAll('.swatch.variant-default').forEach(block => block.style.display = 'block')
        return
      }
      var current_variant_id = document.querySelector('[data-variant-id]').dataset.variantId;
      var current_variant = (current_product.variants || []).find(variant => variant.variant_id == current_variant_id);
      var current_variant_option = current_variant.variant_options;
      var current_variant_option_uppercase = current_variant.variant_options.map(item => item.toUpperCase());
      var all_variants = data.results.map(product => product.variants).flat();
      var product_select = document.querySelector('#productSelect');
      let product_images = new Swiper('.swiper-product-image', {
        loop: false,
        slidesPerView: 4,
        nav: false,
        dots: false,
        spaceBetween: 30,
       });
      document.querySelector('.swiper-wrapper').innerHTML = all_variants.map(
        variant => `<a class="thumbnail swiper-slide" data-image="${variant.variant_image}" data-variant-title="${variant.variant_title.toLowerCase()}"><img src="${variant.variant_image}"></a>`
        ).join('')
      product_select.innerHTML = all_variants.map(
            variant => `<option ${variant.variant_id == current_variant_id ? "selected" : ""} data-variant-image="${variant.variant_image}" data-variant-price="${variant.variant_price}" data-variant-title="${variant.variant_title.toLowerCase()}" data-sku="${variant.variant_sku}" value="${variant.variant_id}">${variant.variant_title} - ${variant.variant_price}</option>`
        ).join('')
      document.querySelector('#productPrice').querySelector('span').innerHTML = product_select.options[product_select.selectedIndex].dataset.variantPrice;
      var option_titles = data.results.map(product => Object.keys(product.options)).flat()
      option_titles = Array.from(new Set(option_titles));
      var product_id = {};
      var options_value = {};
      data.results.forEach(product => {
        Object.keys(product.options).forEach(key => {
            product_id[key] = (product_id[key] || []).concat([product.id + ""])
        })
      })
      for (const option_title of option_titles) {
        data.results.forEach(element => {
            if(element.options[option_title]){
                options_value[option_title] = [].concat(
                    options_value[option_title] || [], element.options[option_title].option.values
                ).map(item => item.toUpperCase())
            }
        });
      }
      var variant_object = {};
      data.results.forEach(item => {
          item.variants.forEach(variant =>{
            variant_object[variant.variant_title] = variant
          })
      })
      Object.keys(options_value).forEach(item => {
          options_value[item] = Array.from(new Set(options_value[item]));
      })
      Object.keys(options_value).forEach((option_name, parent_key) => {
        document.querySelector('.form-group').insertAdjacentHTML("afterend", '<div class="swatch" data-' + option_name.replaceAll(' ', '-') + '><div class="header">' + option_name + ' </div><div class="swatch-select"></div><ul></ul></div></div>')
            options_value[option_name].forEach((option_value, key) => {
            var variant_ids = Object.keys(variant_object).filter(title => title.toUpperCase().includes(option_value)).join('|').toLowerCase();
            document.querySelector('[data-' + option_name.replaceAll(' ', '-') + ']').querySelector('ul').insertAdjacentHTML(
                "beforeend",
                `<li data-product=${(product_id[option_name] || []).join(',')} data-variants="${variant_ids}"
                class="swatch-element swatch-color-custom" data-option-name="${option_name.toLowerCase()}" data-option-value="${option_value.toLowerCase()}">
                    <input name="custom-option-${parent_key}" id="${option_value.replaceAll(' ', '-').toLowerCase()}-${parent_key}-${key}" value="${option_value}" type="radio" ${current_variant_option_uppercase.includes(option_value) ? "checked" : ""}>
                    <label for="${option_value.replaceAll(' ', '-').toLowerCase()}-${parent_key}-${key}">
                    <div class="color_block"></div><span class="name">${option_value}</span>
                    </label>
                </li>`)
        })
        var option_length = document.querySelector('[data-' + option_name.replaceAll(' ', '-') + ']').querySelector('ul');
        if(option_length.children.length >= 4){
            option_length.classList.add('count_4')
        }else{
            option_length.classList.add('count_' + option_length.children.length +'')            
        }
      })

      var swatch_li_inputs = Array.from(document.querySelectorAll('.swatch-element.swatch-color-custom'));
      swatch_li_inputs.forEach(input => {
        input.querySelector('input').addEventListener('change', function(){
            if(this.checked) {
                updateSwatchSelect($(this))
            }
        })
        input.querySelector('input').addEventListener('change', function(){
            var option_products = this.parentElement.dataset.product.split(',');
            var current_check_inputs = swatch_li_inputs.filter(
              li => option_products.filter(
                option_product => li.dataset.product.includes(
                  option_product)).length > 0 && li.querySelector('input:checked') != null).map(
                    li => li.querySelector('input')
                  );
            var current_variant_title = current_check_inputs.map(
                    input => input.value.toLowerCase()
            );
            // var current_variant_title = Array.from(document.querySelectorAll(`[data-product="${this.parentElement.dataset.product}"] input:checked`)
            // ).map(input => input.value.toLowerCase());
            //console.log(this.parentElement.dataset.product)

            var variant_for_select = all_variants.filter(
                variant => (variant.variant_options.length == current_variant_title.length && Array.from(
                  new Set(variant.variant_options.map(
                    opt => opt.toLowerCase()
                    ).concat(current_variant_title))).length == current_variant_title.length) || this.parentElement.dataset.variants.includes(variant.variant_title.toLowerCase()) 
            )[0];
            console.log(variant_for_select)
          //   console.log(all_variants.filter(
          //     variant => variant.variant_options.length == current_variant_title.length
          // ))
            if(variant_for_select){
                document.querySelector('#productSelect').value = variant_for_select.variant_id;
            }else{
                this.checked = "";
                return
            }
            swatch_li_inputs.forEach(li => li.querySelector('label').classList.remove('disabled'))
            var product_arr = this.parentElement.dataset.product.split(',');
            var option_arr = this.parentElement.dataset.variants.split('|').map(data => data.split(' / ')).flat();
            var current_variant = swatch_li_inputs.filter(
                li => this.parentElement != li).filter(
                    li =>{
                          var current_li_product = li.dataset.product.split(',');
                          var uniq_product_id = product_arr.filter(
                            item => current_li_product.filter(current_li_item => item.includes(current_li_item)).length > 0
                          ).length == 0;
                          console.log(li.dataset.optionName, li.dataset.optionValue)
                          console.log(!option_arr.includes(li.dataset.optionValue),
                          uniq_product_id,
                          this.parentElement.dataset.optionName == li.dataset.optionName,
                          option_arr )
                          return (
                              !option_arr.includes(li.dataset.optionValue) ||
                              uniq_product_id ||
                              this.parentElement.dataset.optionName == li.dataset.optionName 
                          )
                    })
            //console.log(current_variant)
            current_variant.forEach(li => (li.querySelector('label').classList.add('disabled')))
            this.parentElement.querySelector('label').classList.remove('disabled');
            document.querySelector('.swiper-product-image .thumbnail[data-variant-title="'+ document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex].dataset.variantTitle +'"]').click();
            document.querySelector('#productPrice').querySelector('span').innerHTML = product_select.options[product_select.selectedIndex].dataset.variantPrice;
            product_select.options[product_select.selectedIndex].dataset.value;
            let current_image_dots = Array.from(document.querySelectorAll('.swiper-product-image .swiper-slide')).findIndex(item => item.getAttribute('data-variant-title') == document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex].dataset.variantTitle);
            let new_variant_url = "" + location.origin + location.pathname + "?variant=" + product_select.options[product_select.selectedIndex].value;
            history.replaceState(null, 'replaceVariant', new_variant_url);
            product_images.slideTo(current_image_dots, 1000, false);
            //console.log(current_image_dots)
            document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex]
        })
      })
      document.querySelector('.swatch-color-custom input:checked').dispatchEvent(new Event("change"))
      $('.swatch .swatch-select').on('click',function () {
        $(this).toggleClass('open');
      });
      document.querySelectorAll('.swatch-color-custom input:checked').forEach(input => {
        updateSwatchSelect($(input))
      })
      function updateSwatchSelect(input) {
        if(input.length == 0) return;
        var select = input.parents('.swatch').find('.swatch-select');
        var el = input.parent().clone();
        el.find('input').remove()
        select.html(el);
        select.removeClass('open');
      }
  }).then(()=>{
    let product_images = new Swiper('.swiper-product-image', {
        loop: false,
        slidesPerView: 4,
        nav: false,
        dots: false,
        spaceBetween: 30,
    });
    $(document).ready(function() {
        var thumbnails_additional = $('#product-product .swiper-product-image .thumbnail');
        thumbnails_additional.each(function(){
          $(this).click(function(){
            $('#ProductPhotoImg').attr('src', $(this).data("image"))
            thumbnails_additional.removeClass('current-additional');
            $(this).addClass('current-additional');
          });
        });
    });
    let current_image_dots = Array.from(document.querySelectorAll('.swiper-product-image .swiper-slide')).findIndex(item => item.getAttribute('data-variant-title') == document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex].dataset.variantTitle);
    product_images.slideTo(current_image_dots, 1000, false);
    
    applySwatchColors();
  }).then(()=>{
    document.querySelector('.swiper-product-image .thumbnail[data-variant-title="'+ document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex].dataset.variantTitle +'"]').classList.add('current-additional')
    document.querySelector('.swiper-product-image .thumbnail[data-variant-title="'+ document.querySelector('#productSelect').options[document.querySelector('#productSelect').selectedIndex].dataset.variantTitle +'"]').dispatchEvent(new Event("click"));
  })
